import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'official_name'

export const dataPointDefinition = {
  retracedId: 'official_name',
  name: 'Official Name',
  description:
    'Official Name is the name on the business license(s) associated with the address indicated below.\r\r\n\r\r\nType Not Applicable if there is no English language business license facility name and complete the other question below:\r\r\n"Facility Name (in local language as per business license):"',
  meta: {},
  fieldTypeId: 'SHORT_TEXT',
  type: 'GLOBAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        minLength: 1,
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-bi-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 10,
  sectionId: '1.1',
  impactArea: 'About',
  impactAreaId: 'ABOUT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
